// 下拉多选框

<template>
  <div class="select-panel">
    <van-row class="select-area" type="flex" justify="flex-start">
      <van-col span="8" class="select-item" @click="reset()"
        :class="[selected.length === 0 ? 'active' : '']">
        不限 </van-col>
      <van-col span="8" class="select-item" @click="clickItem(item, index)"
        v-for="(item, index) in options" :key="index"
        :class="[selected.indexOf(index) !== -1 ? 'active' : '']">
        {{ item.text }} </van-col>
    </van-row>
    <div class="btn-area">
      <div class="btn reset" @click="reset()"> 重置 </div>
      <div class="btn confirm" @click="onConfirm"> 确定 </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectPanel",
  components: {},
  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selected: [],
      selectedValues: []
    };
  },
  computed: {},
  created() {},
  methods: {
    clickItem(item, Index) {
      const pos = this.selected.indexOf(Index);
      if (pos === -1) {
        this.selected.push(Index);
        this.selectedValues.push(item.key);
      } else {
        this.selected.splice(pos, 1);
        this.selectedValues.splice(pos, 1);
      }
    },
    reset() {
      this.selected = [];
      this.selectedValues = [];
    },
    onConfirm() {
      this.$emit("onConfirm", this.selectedValues);
    },
  },
};
</script>

<style scoped>
.select-panel {
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.select-area {
  max-height: 18.4vh;
  overflow: scroll;
  padding: 0px 10px;
  margin: 0;
}

.select-item {
  margin: 5px 6px;
  border-radius: 4px;
  width: 105px;
  height: 34px;
  font-size: 14px;
  background: #f8fafb;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.select-item.active {
  background: rgba(46, 93, 210, 0.1);
  color: #2e5dd2;
}

.btn-area {
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 14px 0 19px;
  margin: 0;
  height: 55px;
  display: flex;
  align-items: center;
}

.btn {
  height: 38px;
  background: #ffffff;
  font-size: 14px;
  border-radius: 22px;
  border: 1px solid #eaedf0;
  line-height: 38px;
}

.reset {
  width: 106px;
  margin-right: 10px;
  font-size: 14px;
}

.confirm {
  font-weight: bold;
  color: #ffffff;
  width: 226px;
  background: linear-gradient(90deg, #3871ff 0%, #2e5dd2 100%);
}
</style>
